import { generatePath } from "react-router-dom";

import { LOB_INVENTORY_ROUTE_MAP, LOB_URL_MAP } from "constants/common";

export const generateUrl = (route, params, query) => {
  if (params) {
    params.inventoryRoute = LOB_INVENTORY_ROUTE_MAP[params.lob];
    params.lob = LOB_URL_MAP[params.lob];
  }
  if (query) {
    query = Object.entries(query).reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});
    query = new URLSearchParams(query).toString();
  }
  const path = generatePath(route, params);
  return query ? `${path}?${query}` : path;
};